import { EventEmitter } from '@angular/core';
import { CommonConstant } from '../../../app.constants';
import { UserService } from '../../../services/user.service';
var MeasurePdfExportComponent = /** @class */ (function () {
    function MeasurePdfExportComponent(userService) {
        this.userService = userService;
        this.closeEvent = new EventEmitter();
        this.exportPDFEvent = new EventEmitter();
        this.exportCSVEvent = new EventEmitter();
        this.isSelectedPostCount = false;
    }
    MeasurePdfExportComponent.prototype.close = function () {
        this.isSelectedPostCount = false;
        this.closeEvent.emit();
    };
    MeasurePdfExportComponent.prototype.onChangePostEngagementPage = function (evt) {
        this.selectedPagePostEngagement = evt;
    };
    MeasurePdfExportComponent.prototype.onChangeRoiPage = function (evt) {
        this.selectedPageRoi = evt;
    };
    MeasurePdfExportComponent.prototype.onChangeInteractionPage = function (evt) {
        this.selectedPageInteraction = evt;
    };
    MeasurePdfExportComponent.prototype.exportCSV = function () {
        this.exportCSVEvent.emit();
    };
    MeasurePdfExportComponent.prototype.exportPdf = function () {
        if (!this.isSelectedPostCount && (this.maxPageInteraction || this.maxPageRoi || this.maxPagePostEngagement)) {
            this.isSelectedPostCount = true;
            return;
        }
        if (!this.selectedPagePostEngagement) {
            this.selectedPagePostEngagement = Math.min(this.maxPagePostEngagement, CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
        }
        if (!this.selectedPageRoi) {
            this.selectedPageRoi = Math.min(this.maxPageRoi, CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
        }
        if (!this.selectedPageInteraction) {
            this.selectedPageInteraction = Math.min(this.maxPageInteraction, CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
        }
        this.exportPDFEvent.emit({
            postEngagementPage: this.selectedPagePostEngagement,
            roiPage: this.selectedPageRoi,
            interactionPage: this.selectedPageInteraction
        });
        // close popup
        this.close();
    };
    Object.defineProperty(MeasurePdfExportComponent.prototype, "canSelectPostPage", {
        get: function () {
            return this.isSelectedPostCount && (this.maxPageInteraction || this.maxPageRoi || this.maxPagePostEngagement);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasurePdfExportComponent.prototype, "canExportCsv", {
        get: function () {
            return this.userService.isEnterpriseAccount() || this.userService.isPremiumAccount();
        },
        enumerable: true,
        configurable: true
    });
    return MeasurePdfExportComponent;
}());
export { MeasurePdfExportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-pdf-export/measure-pdf-export.component.ts.pre-build-optimizer.js